import React from "react";
import * as styles from "./CruiseDrawerSaveThisQuoteDisclaimer.module.scss";
import { Trans } from "@lingui/react/macro";
import { WebQuoteButton } from "components/ECommerceButtons";
import { isPresent } from "src/utils/checks";

type Props = {
  openWebQuoteModal?: () => void;
};

export const CruiseDrawerSaveThisQuoteDisclaimer: React.FC<Props> = ({
  openWebQuoteModal
}) => {
  const showWebQuoteButton = isPresent(openWebQuoteModal);

  return (
    <div className={styles.disclaimerContainer}>
      <div className={styles.disclaimerTextContainer}>
        <div className={styles.title}>
          <Trans>Want to save this quote?</Trans>
        </div>
        <div className={styles.description}>
          <Trans>
            Fill out the form and we’ll send you a detailed PDF with a
            preliminary quote for this voyage.
          </Trans>
        </div>
      </div>
      {showWebQuoteButton && (
        <WebQuoteButton
          variant="secondary"
          size="small"
          onClick={openWebQuoteModal}
          overrideLabel={<Trans>Save this Quote</Trans>}
        />
      )}
    </div>
  );
};
